import { useEffect, useState } from "react";
import axios from "axios";
import { apiURI } from "../../../common";

export function useHistoricalPDFLink(fullPath) {
  const [pdfURL, setPdfURL] = useState(null);

  useEffect(() => {
    let cancelled = false;
    let objectUrl;

    // Fetch the PDF through the backend proxy. The default axios instance carries the JWT,
    // so the backend can stream the bytes from ekfcuatqrmsa/qualityreports via Managed
    // Identity over the private endpoint. `responseType: blob` lets us wrap the bytes in a
    // local object URL that <embed> can render natively (a native src can't send the JWT).
    axios
      .get(`${apiURI}/form/pdf`, {
        params: { path: fullPath },
        responseType: "blob",
      })
      .then((response) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setPdfURL(objectUrl);
      })
      .catch((error) => {
        if (!cancelled) console.log({ error });
      });

    return () => {
      cancelled = true;
      // Free the object URL to avoid leaking blob memory across re-renders.
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fullPath]);

  return pdfURL;
}
